import React, { createContext, useState } from "react";
import PropTypes from "prop-types";

type NavTypes = "services" |
  "slider" |
  "pipeline" |
  "calculator" |
  "map"
export type INavigation = { to: NavTypes, text: string }

export const showedNav: Set<NavTypes> = new Set([])

export const NavContext = createContext({
  navigation: [],
  origNavigation: [],
  setNavigationContext: (nav:INavigation[]) => void nav,
});

const NavCtxProvider = ({children}) => {
  const [navigation, setNavigationContext] = useState<INavigation[]>([]);
  const nav: INavigation[] = [
    {to: "services", text: "Наши услуги"},
    {to: "slider", text: "Примеры работ"},
    {to: "pipeline", text: "Как мы работаем"},
    {to: "calculator", text: "Онлайн-калькулятор"},
    {to: "map", text: "Контакты"},
  ]
  return (
    <NavContext.Provider
      value={{navigation, origNavigation: nav, setNavigationContext}}>{children}</NavContext.Provider>
  );
};

NavCtxProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NavCtxProvider;